var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrTurkey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_24421)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 0H0V45H60V0Z",
    fill: "#E30A17"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8438 23.2035C21.8438 29.4098 26.9625 34.4441 33.2812 34.4441C39.6 34.4441 44.7188 29.4098 44.7188 23.1941C44.7188 16.9785 39.6 11.9629 33.2812 11.9629C26.9625 11.9629 21.8438 16.9973 21.8438 23.2035Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2816 23.2035C21.2816 28.1723 25.3691 32.1941 30.4223 32.1941C35.4754 32.1941 39.5723 28.1629 39.5723 23.1941C39.5723 18.2254 35.4754 14.2129 30.4223 14.2129C25.3691 14.2129 21.2723 18.2348 21.2723 23.2035H21.2816Z",
    fill: "#E30A17"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6223 17.9527L19.716 22.1059L23.5879 23.1559L19.7629 24.5152L19.8566 28.3309L17.3723 25.3496L13.6035 26.6621L15.7785 23.4652L13.1254 20.2871L17.2035 21.4121L19.6223 17.9434V17.9527Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_24421"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrTurkey);
export default __webpack_public_path__ + "static/media/tr Turkey.dc33cf28082509e3acf46434f3c8a9ab.svg";
export { ForwardRef as ReactComponent };